import classNames from "classnames";
import { DetailedHTMLProps, FC, InputHTMLAttributes, ReactNode } from "react";
import Text, { TextProps } from "../Text";
import styles from "./Checkbox.module.scss";

interface CheckboxProps
  extends DetailedHTMLProps<
    InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  label?: string | ReactNode;
  rootClassName?: string;
  align?: "center" | "start";
  labelType?: TextProps["type"];
  labelColor?: string;
  weight?: TextProps["weight"];
}

const Checkbox: FC<CheckboxProps> = ({
  label,
  className,
  rootClassName,
  align = "center",
  labelType = "label-4",
  labelColor,
  weight = 500,
  ...rest
}) => {
  return (
    <div className={rootClassName}>
      <label className={classNames(styles.checkbox, className, styles[align])}>
        <input className={classNames(styles.input)} type="checkbox" {...rest} />
        <span className={styles.checkmark_container}>
          <span className={styles.checkmark} />
        </span>
        {typeof label === "string" ? (
          <Text
            weight={weight}
            htmlTag="span"
            type={labelType}
            color={labelColor}
          >
            {label}
          </Text>
        ) : (
          label
        )}
      </label>
    </div>
  );
};

export default Checkbox;
